import { useEffect } from 'react';
export default function useKeyBoardFocus() {
  useEffect(function () {
    var eventHandler = function eventHandler(event) {
      var keycode = event.which;
      if (keycode === 9) {
        document.body.setAttribute('data-keyboard-focus', 'true');
      }
    };
    var eventClickHandler = function eventClickHandler(event) {
      document.body.setAttribute('data-keyboard-focus', 'false');
    };
    if (!document.body.getAttribute('data-keyboard-focus')) {
      document.body.setAttribute('data-keyboard-focus', 'false');
      window.addEventListener('keydown', eventHandler);
      window.addEventListener('mousedown', eventClickHandler);
    }
    return function () {
      // document.body.removeAttribute('data-keyboard-focus');
      // window.removeEventListener('keydown', eventHandler);
      // window.removeEventListener('mousedown', eventClickHandler);
    };
  }, []);
}